import type React from 'react'

import { cn } from '../lib/utils'

type SmallTextProps = React.HTMLAttributes<HTMLParagraphElement> & {
    children?: React.ReactNode
    testId?: string
    as?: React.ElementType
}

export const SmallText = ({
    className,
    testId,
    as: Component = 'p',
    children,
    ...props
}: SmallTextProps) => {
    return (
        <Component
            data-testid={testId}
            className={cn('text-lp-dark1 text-sm font-normal', className)}
            {...props}
        >
            {children}
        </Component>
    )
}
